(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sales-popup"]) return;
  try {
    
  (function () {
    var root = document.getElementById('sales-pop');
    if (!root) return;
    var poolEl = document.querySelector('[data-sp-pool]');
    var cfgEl = document.querySelector('[data-sp-config]');
    if (!poolEl || !cfgEl) return;
    var pool, cfg;
    try { pool = JSON.parse(poolEl.textContent); cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!Array.isArray(pool) || !pool.length) return;

    var mqMobile = window.matchMedia('(max-width: 639px)');
    if (mqMobile.matches && !cfg.showOnMobile) return;
    var KEY = 'gm_salespop';
    if (cfg.respectDismiss && sessionStorage.getItem(KEY + '_x')) return;

    function list(s) { return String(s || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean); }
    var names = list(cfg.names), cities = list(cfg.cities), times = list(cfg.times);
    if (!names.length) names = [cfg.fallbackName];
    if (!times.length) times = [cfg.fallbackTime];
    function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
    function rand(a, b) { return a + Math.random() * (b - a); }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var linkEl = root.querySelector('[data-sp-link]'), imgEl = root.querySelector('[data-sp-img]'),
        nameEl = root.querySelector('[data-sp-name]'), prodEl = root.querySelector('[data-sp-product]'),
        timeEl = root.querySelector('[data-sp-time]');
    var shown = parseInt(sessionStorage.getItem(KEY + '_n') || '0', 10);
    var last = -1, hideT, cycleT;

    function fill() {
      var i; do { i = Math.floor(Math.random() * pool.length); } while (pool.length > 1 && i === last);
      last = i; var p = pool[i];
      imgEl.src = p.img; imgEl.alt = p.t; linkEl.href = p.u;
      var city = cities.length ? (' ' + cfg.connector + ' ' + pick(cities)) : '';
      nameEl.textContent = pick(names) + city;
      prodEl.textContent = p.t + (p.p ? ' — ' + p.p : '');
      timeEl.textContent = pick(times);
    }
    function show() {
      if (document.hidden) { schedule(cfg.gapMin); return; }
      if (cfg.maxSession > 0 && shown >= cfg.maxSession) return;
      fill(); root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-in'); });
      shown++; try { sessionStorage.setItem(KEY + '_n', shown); } catch (e) {}
      hideT = setTimeout(hide, (cfg.visible || 6) * 1000);
    }
    function hide() {
      root.classList.remove('is-in');
      var done = function () { root.hidden = true; schedule(rand(cfg.gapMin, cfg.gapMax)); };
      reduce ? done() : setTimeout(done, 300);
    }
    function schedule(s) { clearTimeout(cycleT); cycleT = setTimeout(show, s * 1000); }
    function dismiss() {
      clearTimeout(hideT); clearTimeout(cycleT);
      root.classList.remove('is-in'); root.hidden = true;
      if (cfg.respectDismiss) { try { sessionStorage.setItem(KEY + '_x', '1'); } catch (e) {} }
    }
    root.querySelector('[data-sp-close]').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); dismiss(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismiss(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(hideT); });
    schedule(cfg.initial || 6);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  var TIMEOUT = 8000;

  function hydrate(section) {
    if (!section || section.dataset.spReady === '1') return;
    var wrapper = section.querySelector('.jdgm-carousel-wrapper');
    if (!wrapper) return;

    function reveal() {
      section.dataset.spReady = '1';
      section.classList.remove('hidden');
      section.classList.add('is-revealed');
    }

    if (wrapper.children.length > 0) {
      reveal();
      return;
    }
    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      if (wrapper.children.length > 0) {
        reveal();
        observer.disconnect();
      }
    });
    observer.observe(wrapper, { childList: true });
    window.setTimeout(function () { observer.disconnect(); }, TIMEOUT);
  }

  function init(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var sections = scope.querySelectorAll('[data-social-proof]');
    for (var i = 0; i < sections.length; i++) hydrate(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
